import { observer } from 'mobx-react'
import React from 'react'

@observer
class TextStyle extends React.Component {

  render(){
    const { content, colors, size, font, weight, onMouseDown, handleClick } = this.props
    return (
      <div 
        className="col-12"
        draggable
        onMouseDown={onMouseDown}
        onClick={handleClick}
      >
        <div className='text-style-item'>
          <span
            style={{
              color: colors[0].color,
              fontSize: size,
              fontFamily: font,
              fontWeight: weight
            }}
          >
            {content}
          </span>
        </div>
      </div>
    )
  }

}

export default TextStyle